// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/Registration.css
// module id = 1363
// module chunks = 0